<script setup>
import { computed } from 'vue';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  open: { type: Boolean, default: false },
  show: { type: Boolean, default: false },
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  message: { type: String, default: '' },
  confirmLabel: { type: String, default: 'Confirmar' },
  loading: { type: Boolean, default: false },
  variant: { type: String, default: 'primary' },
});

const emit = defineEmits(['close', 'cancel', 'confirm']);

const visible = computed(() => props.open || props.show);
const body = computed(() => props.description || props.message);
const close = () => {
  emit('close');
  emit('cancel');
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisModal :show="visible" :title="title" max-width-class="max-w-md" @close="close">
    <p class="text-sm leading-relaxed text-lais-text-body">{{ body }}</p>
    <template #footer>
      <div class="flex justify-end gap-3">
        <LaisPrimaryButton variant="ghost" :disabled="loading" @click="close">
          Cancelar
        </LaisPrimaryButton>
        <LaisPrimaryButton
          :is-loading="loading"
          :class="variant === 'danger' ? '!bg-rose-600 hover:!bg-rose-700' : ''"
          @click="$emit('confirm')"
        >
          {{ confirmLabel }}
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisModal>
</template>
